import { render, staticRenderFns } from "./BreadModelChildAddDialog.vue?vue&type=template&id=fa7fcd14&scoped=true&"
import script from "./BreadModelChildAddDialog.vue?vue&type=script&lang=js&"
export * from "./BreadModelChildAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./BreadModelChildAddDialog.vue?vue&type=style&index=0&id=fa7fcd14&scoped=true&lang=css&"
import style1 from "./BreadModelChildAddDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7fcd14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
